import { render, staticRenderFns } from "./main-scn.vue?vue&type=template&id=f5ec965c&scoped=true&"
import script from "./main-scn.vue?vue&type=script&lang=js&"
export * from "./main-scn.vue?vue&type=script&lang=js&"
import style0 from "./main-scn.vue?vue&type=style&index=0&id=f5ec965c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ec965c",
  null
  
)

export default component.exports